import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';

const isEnabled = !!import.meta.env.VITE_NEW_RELIC_APP_ID;

if (isEnabled) {
  new BrowserAgent({
    init: {
      distributed_tracing: { enabled: true },
      privacy: { cookies_enabled: true },
      ajax: { deny_list: ['bam.nr-data.net'] },
      page_view_timing: { enabled: true },
      session_replay: {
        enabled: true,
        mask_text_selector: '*',
        sampling_rate: 10,
        error_sampling_rate: 100,
        mask_all_inputs: true,
        collect_fonts: true,
        inline_stylesheet: true,
      },
    },
    info: {
      beacon: 'bam.nr-data.net',
      errorBeacon: 'bam.nr-data.net',
      licenseKey: import.meta.env.VITE_NEW_RELIC_BROWSER_KEY,
      applicationID: import.meta.env.VITE_NEW_RELIC_APP_ID,
      sa: 1,
    },
    loader_config: {
      accountID: import.meta.env.VITE_NEW_RELIC_ACCOUNT_ID,
      trustKey: import.meta.env.VITE_NEW_RELIC_ACCOUNT_ID,
      agentID: import.meta.env.VITE_NEW_RELIC_APP_ID,
      licenseKey: import.meta.env.VITE_NEW_RELIC_BROWSER_KEY,
      applicationID: import.meta.env.VITE_NEW_RELIC_APP_ID,
    },
  });
}
